import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TertiaryButtonComponent } from '@tran-monorepo/frontend/components';
import { NavItem } from '@tran-monorepo/interfaces';
import { ContentSectionComponent } from '../content-section/content-section.component';

@Component({
    selector: 'tran-ui-secondary-navigation',
    imports: [ContentSectionComponent, TertiaryButtonComponent],
    templateUrl: './secondary-navigation.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SecondaryNavigationComponent {
    public readonly navigationItems = input<NavItem[]>([]);

    protected scrollToSection(sectionId: string): void {
        const element = document.getElementById(sectionId);
        if (element) {
            const headerOffset = this.getHeaderHeight();
            const elementPosition = element.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.scrollY - headerOffset;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });

            element.setAttribute('tabindex', '-1');
            element.focus();
        }
    }

    private getHeaderHeight(): number {
        const header = document.querySelector('header');
        return header ? header.getBoundingClientRect().height : 180;
    }
}
